import collection from "@/store/collection.store-partial";
import scoreModule from "@/store/game/scores/single.store";

export default {
	namespaced: true,
	modules: {
		collection,
	},
	getters: {
		averaged: (state, getters) => getters.array.reduce((total, score) => total + score.value, 0)
			/ getters.array.length,
		zeroScore: (state, getters) => getters.array.find(
			(score) => score.value <= 0
		),
	},
	actions: {
		configureApp: {
			root: true,
			async handler({ dispatch }, configData) {
				await dispatch("createHook", {
					type: "add",
					handler: (collectionContext, score) => {
						collectionContext.dispatch(`${score.id}/update`, { value: score.initial_score });
					},
				});

				await dispatch("populate", {
					items: configData.scores,
					path: ["game", "scores"],
					module: scoreModule,
				});
			},
		},
		calculate({ dispatch, getters, rootGetters }) {
			getters.array.forEach((score) => {
				const budget = rootGetters["game/chapters/active"].budgets[score.budget_id];
				dispatch(`${score.id}/calculate`, { ...score, budget });
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/scores/list.store.js